// extracted by mini-css-extract-plugin
export default {"root":"styles_root__r8aOl","disabled":"styles_disabled__Us-t+"};